module.exports = __webpack_public_path__ + "img/no_comment.b85e329e.png";